import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { inventoryApi } from '../../services/inventoryApi.js';

export function BinCreateModal({ open, onClose, warehouseId }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [code, setCode] = useState('');
  const [label, setLabel] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) { setCode(''); setLabel(''); setError(null); }
  }, [open]);

  const save = useMutation({
    mutationFn: () => inventoryApi.createBin({ warehouseId, code: code.trim(), label: label.trim() || undefined }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory', 'bins', warehouseId] });
      onClose();
    },
    onError: (err) => setError(err?.message || t('common.loadError')),
  });

  function submit(e) {
    e.preventDefault();
    setError(null);
    if (!code.trim()) { setError(t('bin.error.code')); return; }
    save.mutate();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('bin.create.title')}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
          <Button variant="primary" onClick={submit} disabled={save.isPending}>
            {save.isPending ? `${t('common.create')}…` : t('common.create')}
          </Button>
        </>
      }
    >
      <form onSubmit={submit} className="form-stack">
        <label className="field">
          <span className="field-label">{t('bin.create.code')}</span>
          <input className="input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="A1-01" required />
        </label>
        <label className="field">
          <span className="field-label">{t('bin.create.label')}</span>
          <input className="input" value={label} onChange={(e) => setLabel(e.target.value)} />
        </label>
        {error && <div className="alert danger">{error}</div>}
      </form>
    </Modal>
  );
}
